import { Outlet } from 'react-router';

import { appRoutes } from '@clearverify/constants';

import { ReactRouteAccessKey } from 'src/constants/reactRouter';
import {
  PeoPayrollProviderDetailBillingPage,
  PeoPayrollProviderDetailCompanyInformationPage,
  PeoPayrollProviderDetailEmployeesPage,
  PeoPayrollProviderDetailEmployersPage,
  PeoPayrollProviderDetailLiveStatusPage,
  PeoPayrollProviderDetailPeosPage,
  PeoPayrollProviderDetailSettingsPage,
  PeoPayrollProviderDetailStaffPage,
} from 'src/pages/peoPayrollProviders';
import { PeosPage } from 'src/pages/peos';
import { RouteProps } from 'src/types/router';

import { PeoPayrollProvidersDetailOutlet } from './components';

const ROUTES: RouteProps[] = [
  {
    index: true,
    element: <PeosPage />,
    accessRoles: [ReactRouteAccessKey.inherit],
  },
  {
    path: appRoutes.peoPayrollProviders.detail.index,
    element: <PeoPayrollProvidersDetailOutlet />,
    childRoutes: [
      {
        path: appRoutes.peoPayrollProviders.detail.companyInformation,
        element: <PeoPayrollProviderDetailCompanyInformationPage />,
        accessRoles: [ReactRouteAccessKey.inherit],
      },
      {
        path: appRoutes.peoPayrollProviders.detail.billing,
        element: <PeoPayrollProviderDetailBillingPage />,
        accessRoles: [ReactRouteAccessKey.inherit],
      },
      {
        path: appRoutes.peoPayrollProviders.detail.staff,
        element: <PeoPayrollProviderDetailStaffPage />,
        accessRoles: [ReactRouteAccessKey.inherit],
      },
      {
        path: appRoutes.peoPayrollProviders.detail.peos,
        element: <PeoPayrollProviderDetailPeosPage />,
        accessRoles: [ReactRouteAccessKey.inherit],
      },
      {
        path: appRoutes.peoPayrollProviders.detail.employers,
        element: <PeoPayrollProviderDetailEmployersPage />,
        accessRoles: [ReactRouteAccessKey.inherit],
      },
      {
        path: appRoutes.peoPayrollProviders.detail.employees,
        element: <PeoPayrollProviderDetailEmployeesPage />,
        accessRoles: [ReactRouteAccessKey.inherit],
      },
      {
        path: appRoutes.peoPayrollProviders.detail.settings,
        element: <PeoPayrollProviderDetailSettingsPage />,
        accessRoles: [ReactRouteAccessKey.inherit],
      },
      {
        path: appRoutes.peoPayrollProviders.detail.liveStatus,
        element: <PeoPayrollProviderDetailLiveStatusPage />,
        accessRoles: [ReactRouteAccessKey.isPlatformAdmin],
      },
    ],
    accessRoles: [ReactRouteAccessKey.inherit],
  },
];

export const PEO_PAYROLL_PROVIDERS_ROUTE: RouteProps = {
  path: appRoutes.peoPayrollProviders.index,
  element: <Outlet />,
  childRoutes: ROUTES,
  accessRoles: [ReactRouteAccessKey.hasPlatformRoles],
};
